<template>
  <div>
    <div class="text-banner text-center">
      <h2><strong>Access Denied</strong></h2>
    </div>
  </div>
</template>

<script>
  export default {}
</script>